import { inject } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  UrlTree,
} from "@angular/router";
import { firstValueFrom } from "rxjs";
import { UserService } from "../core/auth";

export const InvalidCarrierGuard: CanActivateFn = async (
  route: ActivatedRouteSnapshot,
): Promise<boolean | UrlTree> => {
  const router = inject(Router);
  const user = inject(UserService);

  // Wait until the user has been loaded (emit via isLoadedChanges) so we
  // can make a decision without the component being rendered prematurely.
  await firstValueFrom(user.isLoadedChanges);

  const isInvalidCarrierRoute = Boolean(
    route.routeConfig?.path?.includes("invalid-carrier"),
  );

  // If on the invalid-carrier route
  if (isInvalidCarrierRoute) {
    // Only carriers without a carrierKey can access this page
    if (!user.isCarrier() || user.details.carrierKey) {
      return router.parseUrl("/");
    }
    return true;
  }

  // If current user is not carrier then allow the route to pass
  if (!user.isCarrier()) {
    return true;
  }

  // For carrier users on other routes: check if they have a valid carrierKey
  if (user.details.carrierKey) {
    // Carrier is valid, allow the route to pass
    return true;
  }

  // Carrier is invalid, redirect to invalid-carrier page
  return router.parseUrl("/invalid-carrier");
};
